<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="35%">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item prop="productType" label="商品类型">
                    <el-select v-model="form.productType" placeholder="请选择商品类型" style="width:100%;" @change="handleProductTypeChange">
                        <el-option v-for="item in productTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="form.productType !== '3'" prop="buyDateType" label="购买类型">
                    <el-select v-model="form.buyDateType" placeholder="请选择购买类型" style="width:100%;">
                        <el-option v-for="item in buyDateTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="amount" label="金额(元)">
                    <el-input v-model="form.amount" type="number" maxlength="10" style="width:100%;"></el-input>
                </el-form-item>
                <el-form-item prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" type="number" style="width:100%;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../../common/http';

export default {
    data(){
        const validateBuyDateType = (rule, value, callback) => {
            if(this.form.productType === '3'){
                callback();
                return;
            }
            if(value === null || value === undefined || value === ''){
                callback(new Error('请选择购买类型'));
                return;
            }
            callback();
        };
        return{
            visible: false,
            form: {
                id: '',
                productType: '',
                buyDateType: '',
                amount: '',
                orderNum: 1
            },
            productTypeOptions: [
                { value: '1', label: 'VIP' },
                { value: '2', label: 'SVIP' },
                { value: '3', label: 'BVIP' }
            ],
            buyDateTypeOptions: [
                { value: '1', label: '半年' },
                { value: '2', label: '包年' }
            ],
            rules: {
                productType: [{ required: true, message: '请选择商品类型', trigger: 'change' }],
                buyDateType: [{ validator: validateBuyDateType, trigger: 'change' }],
                amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
                orderNum: [{ required: true, message: '请输入排序号', trigger: 'blur' }]
            }
        };
    },
    methods:{
        init(data){
            this.visible = true;
            if (this.$refs['form']) {
                this.$refs['form'].clearValidate();
            }
            this.form.id = data.id;
            this.form.productType = data.productType === null || data.productType === undefined ? '' : String(data.productType);
            this.form.buyDateType = data.buyDateType === null || data.buyDateType === undefined ? '' : String(data.buyDateType);
            if(this.form.productType === '3'){
                this.form.buyDateType = '';
            }
            this.form.amount = data.amount || '';
            this.form.orderNum = data.orderNum === null || data.orderNum === undefined || data.orderNum === '' ? 1 : data.orderNum;
        },
        dialogClose(done){
            done();
            this.$reload;
        },
        handleProductTypeChange(val){
            if(val === '3'){
                this.form.buyDateType = '';
            }
            if(this.$refs['form']){
                this.$refs['form'].clearValidate('buyDateType');
            }
        },
        save(){
            this.$refs['form'].validate((valid) => {
                if(valid){
                    let url = this.memberProductUpdateUrl;
                    let data = {
                        id: this.form.id,
                        productType: this.form.productType,
                        buyDateType: this.form.productType === '3' ? '' : this.form.buyDateType,
                        amount: this.form.amount,
                        orderNum: this.form.orderNum
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message,1);
                            this.visible = false;
                            this.$parent.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }, (err) => {
                        console.log(err);
                    });
                }
            });
        }
    },
    mixins: [http]
};
</script>



// WEBPACK FOOTER //
// src/components/page/member/product/Update.vue